import type {
  CardItemArticleData,
  HeaderProfileData,
  PromoNewsletterData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';

export interface ArticlePageData {
  contentHtml?: string;
  header?: HeaderProfileData;
  newsletter?: PromoNewsletterData;
  articleItems?: CardItemArticleData[];
  moreArticleLink?: LocationDescriptor;
  loading?: boolean;
  onSocialShareClick(): void;
}

export interface ArticlePageProps extends ArticlePageData {}
